export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  author: string;
  image: string;
  content: string[];
  relatedSeriesId: string;
}

export const newsCategories = ["剧情解读", "角色访谈", "幕后花絮", "行业动态"];

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "仙剑奇侠传：李逍遥的成长线，为何至今仍被奉为仙侠剧范本",
    excerpt: "从渝州城的市井少年到肩负苍生的侠者，李逍遥的每一步都踩在“选择”之上，这条成长弧光的完整性，正是经典难以被超越的原因。",
    category: "剧情解读",
    date: "2026-09-28",
    author: "本站编辑 墨闻",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20young%20Chinese%20swordsman%20walking%20a%20misty%20mountain%20path%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20reflective%20cinematic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-01&orientation=landscape",
    content: [
      "李逍遥之所以成为无数观众心中的“仙侠第一男主”，并不只是因为他的洒脱与帅气，而是因为他的成长被写得足够完整。",
      "故事从渝州城的渔村开始，他不过是一个会耍小聪明、爱贪点小便宜的店小二。仙灵岛的一夜，让他与赵灵儿的命运紧紧缠绕，也让他第一次意识到“责任”二字的分量。",
      "真正的成长发生在护送灵儿回南诏的旅途中。锁妖塔、水魔兽、镇妖剑，每一道关卡都在逼迫他做选择：是守护身边的人，还是守护更多的苍生。他的答案从犹豫走向坚定，也让他从一个男孩变成一个真正的侠者。",
      "今天回看这条成长线，它的节奏与层次依然堪称教科书级别——这或许就是经典历久弥新的原因。",
    ],
    relatedSeriesId: "xianjian-1",
  },
  {
    id: "news-02",
    title: "三生三世十里桃花：三世轮回的情感结构拆解",
    excerpt: "白浅与夜华的三世情缘并非简单重复，而是层层递进的情感实验，每一世都在回答“爱能否跨越身份与记忆”。",
    category: "剧情解读",
    date: "2026-09-24",
    author: "本站编辑 云栖",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20peach%20blossoms%20over%20a%20misty%20heavenly%20realm%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20ethereal%20romantic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-02&orientation=landscape",
    content: [
      "《三生三世十里桃花》最迷人的地方，在于它把“轮回”当作情感结构的骨架，而不是噱头。",
      "第一世的司音与墨渊之间是师徒，是敬慕；第二世的素素与夜华之间是凡人夫妻，是相守与失去；第三世的白浅与夜华之间，是平等而清醒的相爱。",
      "三世并非简单叠加，而是一次次把同一个命题推向更深的层次：当身份、记忆与立场都改变时，爱还剩下什么？",
      "正是这种层层递进的写法，让这部作品在多年后依然被反复讨论。",
    ],
    relatedSeriesId: "sansheng",
  },
  {
    id: "news-03",
    title: "主创访谈：把仙剑三的“轮回”拍出来，最难的是什么",
    excerpt: "从飞蓬到景天，从夕瑶到雪见，轮回线的影视化改编需要在有限集数里完成大量信息铺陈，主创团队分享了不少幕后取舍。",
    category: "角色访谈",
    date: "2026-09-20",
    author: "特约撰稿 青鸾",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20celestial%20battle%20between%20immortals%20in%20the%20clouds%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20epic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-03&orientation=landscape",
    content: [
      "谈到《仙剑奇侠传三》的改编难点，主创团队不约而同提到了“轮回”这条线索。",
      "游戏中可以靠大量文本与支线去铺陈前世今生，但影视剧必须在几十集内完成人物弧光的推进，因此每一次前世闪回都要精准地服务于当下人物的选择。",
      "“我们不想把轮回拍成单纯的回忆杀，而是希望观众能感觉到，角色的每一个现在，都是过去无数次选择堆积的结果。”一位编剧这样形容创作思路。",
      "正是这种克制而精准的表达，让三生三世的情感在荧幕上格外动人。",
    ],
    relatedSeriesId: "xianjian-3",
  },
  {
    id: "news-04",
    title: "从游戏到荧幕：仙剑系列的影视化改编之路",
    excerpt: "二十余年间，仙剑从单机游戏走向影视剧，每一次改编都是一次世界观的重建，也见证了整个仙侠剧类型的成长。",
    category: "行业动态",
    date: "2026-09-16",
    author: "本站编辑 墨闻",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20an%20ancient%20Chinese%20sword%20resting%20on%20a%20mountain%20vista%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20nostalgic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-04&orientation=landscape",
    content: [
      "2005 年，《仙剑奇侠传》电视剧的播出，几乎定义了一代观众对“仙侠剧”的初始印象。",
      "此后《仙剑三》《古剑奇谭》《轩辕剑之天之痕》等作品接连登场，把游戏与小说中的东方奇幻世界观带到了更广阔的观众面前。",
      "这种改编并非易事：如何在保留原作精神的同时，满足影视叙事节奏，是每一部作品都要面对的课题。",
      "可以说，仙剑系列的影视化，也是华语仙侠剧类型不断成熟的一个缩影。",
    ],
    relatedSeriesId: "xianjian-3",
  },
  {
    id: "news-05",
    title: "陈情令：为什么“知己”比“爱情”更打动人心",
    excerpt: "魏无羡与蓝忘机的关系之所以动人，是因为它把“懂得”与“守护”写到了极致，超越了任何标签化的定义。",
    category: "剧情解读",
    date: "2026-09-12",
    author: "本站编辑 云栖",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20two%20figures%20by%20a%20lotus%20pond%20in%20misty%20mountains%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20quiet%20emotional%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-05&orientation=landscape",
    content: [
      "《陈情令》最被观众津津乐道的，是魏无羡与蓝忘机之间那种无需言说的默契。",
      "他们性格迥异，一个跳脱不羁，一个端方自持，却在一次次生死抉择中成为彼此唯一信任的人。",
      "这种关系的动人之处在于“懂得”：蓝忘机懂得魏无羡的善良，魏无羡也懂得蓝忘机的坚守。",
      "当情感被写成理解与守护，它便拥有了超越标签的力量。",
    ],
    relatedSeriesId: "chenqingling",
  },
  {
    id: "news-06",
    title: "幕后花絮：仙侠剧里的“御剑飞行”是怎么拍出来的",
    excerpt: "威亚、棚拍、绿幕与后期合成，一段看似轻盈的御剑镜头，往往是团队数周协作的成果。",
    category: "幕后花絮",
    date: "2026-09-08",
    author: "特约撰稿 青鸾",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20swordsman%20soaring%20above%20clouds%20with%20glowing%20light%20trails%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20dynamic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-06&orientation=landscape",
    content: [
      "在很多观众眼里，仙侠剧里最浪漫的画面莫过于御剑飞行。但这份浪漫背后，是实打实的技术活。",
      "演员需要借助威亚完成腾空与平衡，同时还要兼顾表情与动作的舒展；而背景的天空、云海与山峦，往往由后期团队逐帧合成。",
      "一个只有几秒的飞行镜头，可能需要剧组反复拍摄数十条素材，再经过渲染与调色才能最终呈现。",
      "所以下次再看到主角乘风而起，不妨也为幕后的团队鼓个掌。",
    ],
    relatedSeriesId: "gujianqitan",
  },
  {
    id: "news-07",
    title: "苍兰诀：轻喜剧外壳下的“双向救赎”",
    excerpt: "小兰花与东方青苍的相遇看似轻快，实则藏着两个孤独灵魂彼此治愈的深意。",
    category: "剧情解读",
    date: "2026-09-03",
    author: "本站编辑 墨闻",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20fairy%20girl%20and%20a%20demon%20lord%20under%20a%20starry%20sky%20realm%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20warm%20playful%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-07&orientation=landscape",
    content: [
      "《苍兰诀》用诙谐的开局吸引了大量观众，但真正让人上头的，是它的情感内核。",
      "小兰花的善良并非软弱，东方青苍的强势也并非无情，两人在彼此的陪伴中学会了“被需要”和“去守护”。",
      "这种双向救赎的关系，让剧情在轻松之外多了一层温柔的深度。",
      "当轻喜剧的外壳遇上扎实的情感线，作品的吸引力便自然被放大。",
    ],
    relatedSeriesId: "canglanjue",
  },
  {
    id: "news-08",
    title: "古剑奇谭：百里屠苏的“煞气”其实是一种隐喻",
    excerpt: "焚寂煞气既是剧中的核心设定，也隐喻着每个人心中难以言说的阴影与自我和解的过程。",
    category: "剧情解读",
    date: "2026-08-29",
    author: "本站编辑 云栖",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20lone%20swordsman%20in%20a%20sunflower%20valley%20at%20dusk%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20melancholic%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-08&orientation=landscape",
    content: [
      "在《古剑奇谭》里，“焚寂煞气”是推动剧情的重要设定，但它同时也是一个绝妙的隐喻。",
      "百里屠苏始终在与体内的煞气抗争，这份抗争其实象征着一个人与自身阴影的博弈。",
      "风晴雪与伙伴们的陪伴，则像是一束照进黑暗的光——真正的救赎，从来都不是消灭阴影，而是学会与它共存。",
      "也正因如此，这个角色的挣扎才格外令人共情。",
    ],
    relatedSeriesId: "gujianqitan",
  },
  {
    id: "news-09",
    title: "新作观察：近年仙侠剧的“新派美学”从哪里来",
    excerpt: "更克制的配色、更电影感的运镜与更细腻的人物刻画，正在成为新一代仙侠剧的共同标签。",
    category: "行业动态",
    date: "2026-08-24",
    author: "本站编辑 墨闻",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20modern%20minimal%20xianxia%20mountain%20scene%20with%20golden%20light%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20refined%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-09&orientation=landscape",
    content: [
      "如果说早期的仙侠剧以浓烈的色彩和高饱和度著称，那么近年的作品明显走向了另一种审美。",
      "墨绿、靛青、米白成为常见的主色，运镜更接近电影的呼吸感，人物的情感表达也更加收敛细腻。",
      "这种变化背后，是观众审美的成熟，也是制作水准整体提升的体现。",
      "可以预见，“新派仙侠美学”还会继续演化，给观众带来更多惊喜。",
    ],
    relatedSeriesId: "xianjian-4",
  },
  {
    id: "news-10",
    title: "角色访谈：解读徐长卿“三生三世只为一人的执念”",
    excerpt: "在道义与深情之间，徐长卿给出了属于他自己的答案，也让观众重新理解了“执着”的重量。",
    category: "角色访谈",
    date: "2026-08-19",
    author: "特约撰稿 青鸾",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20white%20robed%20daoist%20immortal%20standing%20on%20a%20misty%20peak%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20solemn%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-10&orientation=landscape",
    content: [
      "徐长卿是《仙剑三》里最具争议也最令人难忘的角色之一。",
      "身为蜀山弟子，他一生都在“修大道”与“护一人”之间拉扯。紫萱的出现，让这份拉扯变成了三生三世的坚守。",
      "有观众说他是“最深情也最不幸的人”，也有人认为他的执着本身就是一种圆满。",
      "无论怎样解读，这个角色都让“执念”二字有了更立体的重量。",
    ],
    relatedSeriesId: "xianjian-3",
  },
  {
    id: "news-11",
    title: "花千骨：师徒关系为何总能在仙侠剧中引发共鸣",
    excerpt: "规矩与情感的冲撞，是师徒题材永恒的魅力所在，也是仙侠叙事中极具张力的一种关系结构。",
    category: "剧情解读",
    date: "2026-08-14",
    author: "本站编辑 云栖",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20master%20and%20disciple%20in%20a%20petal%20filled%20immortal%20garden%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20tender%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-11&orientation=landscape",
    content: [
      "师徒关系之所以在仙侠剧中频繁出现，是因为它天然带有“禁忌感”与“责任”。",
      "师父代表着规矩与道义，弟子则代表着变数与情感，两者的碰撞必然产生张力。",
      "《花千骨》正是把这种张力发挥到了极致，也让观众在心疼角色的同时，思考情感与规则的边界究竟在哪里。",
      "这或许就是师徒题材经久不衰的原因。",
    ],
    relatedSeriesId: "huqiangu",
  },
  {
    id: "news-12",
    title: "本站专题：值得重温的十部经典仙侠剧",
    excerpt: "从《仙剑奇侠传》到《陈情令》，我们整理了一份跨越二十年的经典仙侠剧清单，献给每一位剧迷。",
    category: "行业动态",
    date: "2026-08-09",
    author: "本站编辑 墨闻",
    image: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20constellation%20of%20glowing%20swords%20and%20stars%20over%20mountains%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20grand%20mood%2C%20no%20text&width=900&height=560&seq=xj-news-12&orientation=landscape",
    content: [
      "仙侠剧走过二十余年，留下了太多值得反复回味的作品。",
      "从开创类型的《仙剑奇侠传》，到情感细腻的《三生三世》与口碑扎实的《陈情令》，每一部都代表着一个阶段的审美。",
      "我们按照年代与类型整理了这份清单，希望能帮你找到想要重温的那一部。",
      "你也可以在分类页按年代、地区与副分类自由筛选，定制属于自己的观影路线。",
    ],
    relatedSeriesId: "xianjian-1",
  },
];

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}